import { BlanchingCooking } from "../entities/blanching-cooking.entity";
import { BlanchingCookingDTO } from "./blanching-cooking.dto";

export class BlanchingCookingAdapter {
    public convertDtoToEntity(dto: BlanchingCookingDTO,isUpdate: boolean = false):BlanchingCooking{
        const entity = new BlanchingCooking;
        entity.cookingId = dto.cookingId
        entity.logId = dto.logId
        entity.time = dto.time
       entity.blanchingCooking = dto.blanchingCooking
        entity.temp1 = dto.temp1
        entity.temp2 = dto.temp2
        entity.temp3 = dto.temp3
        entity.cookingTime = dto.cookingTime
        entity.productCoreTemp = dto.productCoreTemp
        entity.productTempAfterChilling = dto.productTempAfterChilling
        entity.steamPressure = dto.steamPressure
        entity.chillWaterTemp = dto.chillWaterTemp
        entity.chillerTime = dto.chillerTime
        entity.remarks = dto.remarks
        entity.correctiveAction = dto.correctiveAction
        if(dto.cookingId){
            entity.cookingId = dto.cookingId;
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.createdUser = dto.createdUser;
        }
        return entity;

        
}

        public convertEntityToDto(obj: BlanchingCooking) : BlanchingCookingDTO {
            const dto= new BlanchingCookingDTO;
        dto.cookingId = obj.cookingId;
        dto.logId = obj.logId;
        dto.blanchingCooking = obj.blanchingCooking;
        dto.time = obj.time
        dto.temp1 = obj.temp1;
        dto.temp2 = obj.temp2;
        dto.temp3 = obj.temp3;
        dto.cookingTime = obj.cookingTime;
        dto.productCoreTemp = obj.productCoreTemp;
        dto.productTempAfterChilling = obj.productTempAfterChilling;
        dto.steamPressure = obj.steamPressure;
        dto.chillWaterTemp = obj.chillWaterTemp;
        dto.chillerTime = obj.chillerTime;
        dto.remarks = obj.remarks;
        dto.correctiveAction = obj.correctiveAction
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        return dto; 
        }

}